// CLIENTS
export const GET_CLIENTS = 'GET_CLIENTS';
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS';
export const GET_CLIENT = 'GET_CLIENT';
export const GET_CLIENT_SUCCESS = 'GET_CLIENT_SUCCESS';
export const CREATE_CLIENT = 'CREATE_CLIENT';
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS';
export const DELETE_CLIENT = 'DELETE_CLIENT';
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS';
export const SELECT_CLIENT = 'SELECT_CLIENT';
export const ADD_CLIENT = 'ADD_CLIENT';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS';
export const EDIT_CLIENT = 'EDIT_CLIENT';
export const CANCEL_CREATE = 'CANCEL_CREATE';
export const CANCEL_UPDATE = 'CANCEL_UPDATE';
export const CLIENTS_ERROR = 'CLIENTS_ERROR';
export const GET_CLIENT_AUDIT_LOGS = 'GET_CLIENT_AUDIT_LOGS';
export const GET_CLIENT_AUDIT_LOGS_SUCCESS = 'GET_CLIENT_AUDIT_LOGS_SUCCESS';
export const GET_CLIENT_WHITELABEL = 'GET_CLIENT_WHITELABEL';
export const CREATE_CLIENT_WHITELABEL = 'CREATE_CLIENT_WHITELABEL';
export const DELETE_CLIENT_WHITELABEL = 'DELETE_CLIENT_WHITELABEL';

// SUBSCRIPTIONS
export const SET_CLIENT = 'SET_CLIENT';
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';
export const ADD_SUBSCRIPTION_CLIENT = 'ADD_SUBSCRIPTION_CLIENT';
export const ADD_SUBSCRIPTION_CLIENT_SUCCESS = 'ADD_SUBSCRIPTION_CLIENT_SUCCESS';
export const REMOVE_SUBSCRIPTION_CLIENT = 'REMOVE_SUBSCRIPTION_CLIENT';
export const REMOVE_SUBSCRIPTION_CLIENT_SUCCESS = 'REMOVE_SUBSCRIPTION_CLIENT_SUCCESS';
export const UPDATE_CLIENT_APPS = 'UPDATE_CLIENT_APPS';
export const ADD_LOADING_CLIENT = 'ADD_LOADING_CLIENT';
export const REMOVE_LOADING_CLIENT = 'REMOVE_LOADING_CLIENT';
export const CLEAR_LOADING_CLIENT = 'CLEAR_LOADING_CLIENT';
export const UPDATE_USER_LIST = 'UPDATE_USER_LIST';
export const UPDATE_CLIENT_LIST = 'UPDATE_CLIENT_LIST';
export const UPDATE_APPROLE_LIST = 'UPDATE_APPROLE_LIST';
export const SET_CAPUROLE = 'SET_CAPUROLE';
